module.exports = __webpack_public_path__ + "c6e432d7e956c5c57575d12ae00d5a11.fbx";